import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import icon from './icon.svg';

//------------------------------------------------------------------------------

const Toggle = ({ children, className, active, onClick, onFocus }) => {
  const classNameRoot = classNames(
    'Toggle',
    { 'Toggle--active': active },
    className,
  );
  return (
    <button
      type="button"
      className={classNameRoot}
      onClick={onClick}
      onFocus={onFocus}
    >
      <span className="Toogle__inner">
        <span className="Toogle__children">
          {children}
        </span>
        <span className="Toogle__icon">
          <img src={icon} className="Toogle__icon-img" alt="" />
        </span>
      </span>
    </button>
  );
};

Toggle.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
};

Toggle.defaultProps = {
  className: null,
  active: false,
  onClick: null,
  onFocus: null,
};

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/Form/Field/Select/Toggle/index.js